<table class="min-w-full">
  <thead class="border-b">
    <tr>
      <ng-container *ngTemplateOutlet="
        headers;
        context: {$implicit: data}
      "></ng-container>
    </tr>
  </thead>
  <tbody>
    <ng-container *ngFor="let row of data | async" class="border-b">
      <tr >
        <ng-container *ngTemplateOutlet="rows; context: { $implicit: row}">
        </ng-container>
      </tr>
    </ng-container>
  </tbody>
</table>
